import { getProfessionalCampaigns } from './GetProfessionalCampaigns';
import { getCampaigns } from './GetCampaigns';
import { getCampaign } from './GetCampaign';
import { getCampaignReport } from './GetCampaignReport';
import { getOfficeDiscountHistory } from './GetOfficeDiscountHistory';

export const CampaignsApi = {
  getProfessionalCampaigns,
  getCampaigns,
  getCampaign,
  getCampaignReport,
  getOfficeDiscountHistory,
};

export { CAMPAIGNS_ENDPOINT, CAMPAIGNS_MAX_LIMIT } from './GetCampaigns';
